export default {
    WAITING: "WAITING",
}